const loginStyles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		flex: 1,
		padding: {
			xs: '5rem 1.5rem 4rem 1.5rem',
			sm: '5rem 1.5rem 4rem 1.5rem',
			md: '5rem 5.5rem 6.2rem 5.5rem',
		},

		position: 'relative',
		width: '100%',
		minHeight: '100%',
	},
	containerWithoutStepper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		flex: 1,
		padding: {
			xs: '6rem 1.5rem 3rem 1.5rem',
			sm: '6rem 1.5rem 3rem 1.5rem',
			md: '6rem 5.5rem 6.2rem 5.5rem',
		},
		position: 'relative',
		width: '100%',
		minHeight: '100%',
	},
	subHeading: {
		lineHeight: '145%',
		fontSize: '0.875rem',
		m: '1rem 1.23rem 0 0',
		display: 'flex',
		flex: { xs: 3, md: 'unset' },
		alignItems: 'center',
		fontWeight: 400,
	},
	otpContainer: { gap: '0.5rem', alignItems: 'flex-start' },
	otpText: {
		textAlign: 'left',
		fontSize: { xs: '0.75rem', md: '0.875rem' },
		width: '100%',
		borderRadius: '12px',
	},
	heading: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},
	headingText: {
		fontSize: '1rem',
		fontWeight: 600,
	},
	inputContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		width: '100%',
		gap: '0.75rem',
	},
	tcLabel: { whiteSpace: 'pre-wrap', display: 'flex' },
	tncLabel: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		fontSize: '12px',
		fontWeight: 400,
		mt: '0.5rem',
		flexWrap: 'wrap',
	},
	footerContainer: {
		position: 'absolute',
		width: '100%',
		bottom: 0,
		left: 0,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		// py: '0.875rem',
		px: '0.7rem',
		py: '10px',
		justifyContent: 'space-around',
		gap: '10px',
	},
	footerContainerMobile: {
		width: '100%',
		bottom: 0,
		left: 0,
		display: 'flex',
		alignItems: 'center',
		height: '0.5rem',
		pt: '0.875rem',
	},
	footerTextNew: {
		fontSize: '10px',
		fontWeight: 400,
		// lineHeight: '145%',
	},
	footerText: {
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '145%',
	},
	lockIconMobile: {
		width: '16px',
		height: '16px',
		'& .MuiAvatar-img': {
			objectFit: 'contain',
		},
		color: 'green',
	},
	lockIcon: {
		width: '25px',
		height: '25px',
		'& .MuiAvatar-img': {
			objectFit: 'contain',
		},
		color: 'green',
	},
	backContainer: {
		width: '100%',
	},
	backIcon: {
		width: '16px',
		height: '16px',
		'& .MuiAvatar-img': {
			objectFit: 'contain',
		},
	},
};

export default loginStyles;
